export default defineAppConfig({
	ui: {
		colors: {
			primary: "primary",
			neutral: "zinc",
		},
		icons: {
			loading: "i-heroicons-arrow-path-20-solid",
		},
		table: {
			slots: {
				td: "p-2",
				th: "px-2 py-2",
			},
		},
	},
});
